module.exports = __webpack_public_path__ + "static/media/momo12.20334446.jpg";